import { Briefcase, Gavel, Scale, FileText, Users, TrendingUp, ShieldCheck, Clock } from 'lucide-react';

export const companyInfo = {
  name: 'FINANJU',
  cvr: '33571658',
  address: 'Bosagergården 11 st. tv.',
  zipCity: '6400 Sønderborg',
  email: 'kontakt@finanju.dk',
  phone: '40 15 49 69',
};

export const services = [
  {
    id: 'økonomisk-rådgivning',
    title: 'Økonomisk Rådgivning',
    description: 'Vi tilbyder dybdegående økonomisk analyse og strategisk rådgivning for at optimere din virksomheds drift og vækst.',
    icon: TrendingUp,
    link: '/oekonomisk-raadgivning',
    bullets: [
      'Strategisk budgettering og forecasting',
      'Likviditetsstyring og cash flow optimering',
      'Rapportering og nøgletalsanalyser'
    ]
  },
  {
    id: 'juridisk-rådgivning',
    title: 'Juridisk Rådgivning',
    description: 'Kompetent juridisk sparring inden for erhvervsret, kontrakter og compliance, der sikrer din virksomheds fundament.',
    icon: Gavel,
    link: '/juridisk-raadgivning',
    bullets: [
      'Kontraktret og erhvervsretlige aftaler',
      'Selskabsret og omstrukturering',
      'Compliance og risikostyring'
    ]
  },
  {
    id: 'interim-management',
    title: 'Interim Management',
    description: 'Fleksible løsninger til tidsbegrænsede behov for ledelse eller specialistkompetencer i din økonomifunktion.',
    icon: Clock,
    link: '/interim-opgaver',
    bullets: [
      'Midlertidig CFO eller Finance Manager',
      'Hurtig eksekvering og procesoptimering',
      'Fleksibel ressource i spidsbelastninger'
    ]
  },
  {
    id: 'full-service-løsninger',
    title: 'Full Service Løsninger',
    description: 'En komplet varetagelse af dine økonomiske og juridiske processer, så du kan fokusere på din kerneforretning.',
    icon: ShieldCheck,
    link: '/full-service',
    bullets: [
      'Komplet bogføring, moms og lønadministration',
      'Udarbejdelse og indberetning af årsregnskab',
      'Løbende økonomisk og juridisk sparring'
    ]
  }
];

export const oekonomiskDetails = [
  {
    title: 'Strategisk Budgettering & Prognoser',
    description: 'Vi udarbejder realistiske budgetter og løbende prognoser, der sikrer, at din virksomhed styrer efter de rette mål.'
  },
  {
    title: 'Likviditetsstyring & Cash Flow',
    description: 'Få fuldt overblik over dit cash flow, optimer arbejdskapitalen og undgå ubehagelige overraskelser.'
  },
  {
    title: 'Rapportering & KPI-analyser',
    description: 'Vi opsætter overskuelige dashboards og ledelsesrapporter, der gør komplekse tal letforståelige og handlingsorienterede.'
  }
];

export const juridiskDetails = [
  {
    title: 'Kontrakter & Erhvervsret',
    description: 'Udarbejdelse, gennemsyn og forhandling af kommercielle aftaler, samarbejdsaftaler og ansættelseskontrakter.'
  },
  {
    title: 'Selskabsret & Omstrukturering',
    description: 'Rådgivning om selskabsstruktur, stiftelse, ejeraftaler samt bistand ved fusioner eller generationsskifte.'
  },
  {
    title: 'Compliance & Risikostyring',
    description: 'Sikring af, at din virksomhed overholder gældende lovgivning, herunder GDPR og branchespecifikke regler.'
  }
];

export const interimDetails = [
  {
    title: 'Økonomistyring',
    description: 'Interim CFO eller Finance Manager til at styrke økonomifunktionen i overgangsperioder.'
  },
  {
    title: 'Projektledelse',
    description: 'Implementering af nye systemer eller optimering af eksisterende processer.'
  },
  {
    title: 'Særlige Indsatser',
    description: 'Håndtering af specifikke opgaver som årsafslutning, budgettering eller due diligence.'
  }
];

export const fullServiceDetails = [
  {
    title: 'Bogføring & Rapportering',
    description: 'Præcis og rettidig bogføring samt ledelsesrapportering.'
  },
  {
    title: 'Lønadministration',
    description: 'Fejlfri håndtering af løn og relaterede administrative opgaver.'
  },
  {
    title: 'Årsregnskab',
    description: 'Udarbejdelse af årsrapporter og sikring af korrekt skattehåndtering.'
  }
];
